import {
  Box,
  CustomModalLayout,
  Divider,
  Heading,
  Text,
  TextButton,
} from '@wix/design-system';
import React from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { DataHooks } from '../../../../constants/dataHooks';
import { useTemplatesData } from '../../../../hooks/useTemplatesData';
import { useTemplatesPageBi } from '../../../../hooks/useTemplatesPageBi';
import css from '../../TemplatePage.scss';
import { PreSteps, PrerequisiteStep, prerequisiteSteps } from './PreSteps';
import { TerminalExample } from './TerminalExample/TerminalExample';

interface GetStartWithCLIModalLayoutProps {
  closeModal: () => void;
}

export const GetStartWithCLIModalLayout = ({
  closeModal,
}: GetStartWithCLIModalLayoutProps) => {
  const { t } = useTranslation();
  const { currentTemplate: template } = useTemplatesData();
  const { reportCloseCliModalClick, reportCliPrerequisiteLinkClick } =
    useTemplatesPageBi();
  const learnMoreLink = prerequisiteSteps[PrerequisiteStep.CliLearnMore];

  const onLinkClick = () => {
    reportCliPrerequisiteLinkClick(
      template.id,
      PrerequisiteStep.CliLearnMore,
      learnMoreLink,
    );
  };

  const onCloseClick = () => {
    reportCloseCliModalClick(template.id);
    closeModal();
  };

  return (
    <CustomModalLayout
      dataHook={DataHooks.CLIModalLayout}
      width={600}
      showHeaderDivider
      showFooterDivider
      title={t('app.template-page.modal.cli.title')}
      primaryButtonText={t('app.template-page.modal.primary-button')}
      onCloseButtonClick={onCloseClick}
      primaryButtonOnClick={onCloseClick}
    >
      <Heading size="small">
        {t('app.template-page.modal.cli.steps-title')}
      </Heading>
      <Text size="small" weight="thin">
        {t('app.template-page.modal.cli.steps-subtitle')}
      </Text>
      <PreSteps />
      <div className={css.modalDivider}>
        <Divider />
      </div>
      <Heading size="small">
        {t('app.template-page.modal.cli.select-and-copy-title')}
      </Heading>

      <Box verticalAlign="middle" gap="2px">
        <Text size="small" weight="thin">
          {t('app.template-page.modal.cli.select-and-copy-subtitle')}
        </Text>
        <TextButton
          as="a"
          size="small"
          weight="thin"
          target="_blank"
          onClick={onLinkClick}
          href={learnMoreLink}
          dataHook={DataHooks.CLIModalLearnMoreLink}
        >
          {t('app.template-page.modal.cli.select-and-copy-learn-more')}
        </TextButton>
      </Box>
      <TerminalExample />
    </CustomModalLayout>
  );
};
